import {defineStore} from 'pinia';

type SpecSheetState = {
    specSheets: Record<string, boolean>
}

export const useSpecSheetStore = defineStore('specSheet', {
    state: (): SpecSheetState => ({
        specSheets: {},
    }),

    actions: {
        async check(article: { articleNumber?: string }) {
            const articleNumber = article?.articleNumber;
            if (!articleNumber) return false;

            if (this.specSheets[articleNumber] === undefined) {
                try {
                    const {public: pub} = useRuntimeConfig();

                    // Erwartet: { hasPDF: boolean }
                    const res = await $fetch<{ hasPDF: boolean }>(
                        `${pub.configuratorURL}/getArticleNumberHasPDF/${encodeURIComponent(articleNumber)}`,
                        {
                            // wichtig: keine Credentials/Headers erzwingen
                            credentials: 'omit',
                        },
                    );

                    this.specSheets[articleNumber] = !!res?.hasPDF;
                } catch (e) {
                    console.error('failed to check article number', e);
                    this.specSheets[articleNumber] = false;
                }
            }

            return this.specSheets[articleNumber];
        },

        async download(article: { articleNumber?: string }) {
            if (import.meta.server) return;
            const articleNumber = article?.articleNumber;
            if (!articleNumber) return;

            const filename = `${articleNumber}.pdf`;
            const {public: pub} = useRuntimeConfig();

            const arrayBuffer = await $fetch<ArrayBuffer>(
                `${pub.configuratorURL}/pdf/artikel/${encodeURIComponent(filename)}`,
                {
                    responseType: 'arrayBuffer',
                    credentials: 'omit',
                },
            );

            const blob = new Blob([arrayBuffer], {type: 'application/pdf'});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(link.href);
        },

        async openInNewTab(article: { articleNumber?: string }) {
            if (import.meta.server) return;
            const articleNumber = article?.articleNumber;
            if (!articleNumber) return;

            const filename = `${articleNumber}.pdf`;
            const {public: pub} = useRuntimeConfig();

            const arrayBuffer = await $fetch<ArrayBuffer>(
                `${pub.configuratorURL}/pdf/artikel/${encodeURIComponent(filename)}`,
                {
                    responseType: 'arrayBuffer',
                    credentials: 'omit',
                },
            );

            const blob = new Blob([arrayBuffer], {type: 'application/pdf'});
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank', 'noopener,noreferrer');
            // optional: später freigeben
            setTimeout(() => URL.revokeObjectURL(url), 60_000);
        },
    },
});
